import React from "react";
import { v4 as uuid } from "uuid";
import "./index.css";

const TextChild = ({ text }) => {
  return (
    <div className="text-child">
      {text.map((p) => (
        <p className="text-child__text" key={uuid()}>
          {p}
        </p>
      ))}
    </div>
  );
};

export default TextChild;
